import { render, staticRenderFns } from "./ArticleNewsletter.vue?vue&type=template&id=be40b424&scoped=true"
import script from "./ArticleNewsletter.vue?vue&type=script&lang=ts"
export * from "./ArticleNewsletter.vue?vue&type=script&lang=ts"
import style0 from "./ArticleNewsletter.vue?vue&type=style&index=0&id=be40b424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be40b424",
  null
  
)

export default component.exports